import { useEffect, useRef, useState } from "react";

import nextArr from '../assets/ALeft.png'
import prevArr from '../assets/ARight.png'

import dummy from '../assets/body.png'
// import { dummyImg } from '../../Data'

// import '../fabric.css'

import default_shirt from '../assets/SHIRT.png'

function ViewImages({sel, single, loading, setLoading, imgState, setImgState, type}) {
    // const [imgState, setImgState] = useState(0)
    const [Single, setSingle] = useState()
    const [state, setState] = useState(1)

    useEffect(()=>{ 
        console.log("type received ", type)

        

        if(type === 1){
            // Every piece in this order (kurta, pajama, sadri… not only the
            // suit's coat, vest, pant and shirt), skipping any without photos.
            const p = Array.isArray(sel && sel.types) && sel.types.length ? sel.types : Object.keys((sel && sel.fabric) || {})
            let data = []
            p.forEach((typS)=>{
                const single = sel && sel.fabric && sel.fabric[typS] && sel.fabric[typS]["single"]
                if (Array.isArray(single)) data = [...data, ...single]
            })
            console.log("data from profile", data)
            setSingle(data)
            setState(data.length + 1)
        }else{
            setState(((single && single.length) || 0) + 1)
        }
    }, [])
    const counter = useRef(0);
    const imageLoaded = () => {
        counter.current += 1;
        let L = 0;
        if(imgState === 0){
            L = sel.types.length + 1
            // L = sel.types.length
        }else{
            L = 1
        }
        
        if (counter.current >= L) {
            setLoading(false);
            counter.current = 0;
        }
    }

    return ( 
        <div className="v-d-body"
        >
            {/* https://stackoverflow.com/questions/56902522/react-show-loading-spinner-while-images-load */}
            {/* {loading && (<div className='f-loading'
            >
                <img alt src="https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.svg" onerror="this.src='https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'"/>
            </div>)} */}
            {sel && sel.types && imgState === 0 ? (
                <>
                    {/* <img src={shirt} className='v-display-img-full'/>
                    <img src={jacket} className='v-display-img-full'/>
                    <img src={coat} className='v-display-img-full'/>
                    <img src={pant} className='v-display-img-full'/> */}
                    <img src={dummy} className='v-display-img-full'
                        onLoad={imageLoaded}
                        style={!sel.types.includes("Pant") || imgState > 0 ?{"display":"none"}:{} }
                    />
                    <img src={default_shirt} className='v-display-img-full'
                        onLoad={imageLoaded}
                        style={!sel.types.includes("Pant") || imgState > 0 ?{"display":"none"}:{} }
                    />
                    {sel.types.map((val, key)=>{
                        return(
                            <img src={ sel && sel.fabric && Object.hasOwn(sel.fabric, val) ? sel.fabric[val]["src"] : "" }
                                onLoad={imageLoaded}
                                style={ 
                                     {"zIndex":50-(Number(sel.fabric && sel.fabric[val] && sel.fabric[val]["pos"]) || 0)} } 
                                className= {sel.types.includes("Pant") ? "v-display-img-full":"v-display-img"}/>
                        )
                    })}
                </>
            ): imgState > 0 ?
            (<>

            {/* 1. Coat
            2. vest
            3. Pant
            4. Shirt */}
            
                {/* <img src={s2} className='v-display-img-full' onLoad={imageLoaded}/>
                <img src={s5} className='v-display-img-full' onLoad={imageLoaded}/>
                <img src={s3} className='v-display-img-full' onLoad={imageLoaded}/>
                <img src={s1} className='v-display-img-full' onLoad={imageLoaded}/> */}
                {/* {type && type === 0 ? (<>
                
                </>)
                : (<></>)
                } */}
                { type === 0 && single && single[imgState-1] && single[imgState-1]["typ"] === 0 ? (
                    <img src={single[imgState-1]["src"]} className='v-display-img-full'
                        onLoad={imageLoaded}
                    />
                ) : (<>
                    {type===0 && single && single[imgState-1] && Array.isArray(single[imgState-1]["src"]) && single[imgState-1]["src"].map((imgV, imgKey)=>{
                        return(
                            <img src={imgV} className='v-display-img-full'
                                onLoad={imageLoaded}
                            />
                        )
                    })

                    }
                </>)

                }

                {type && type === 1 ? (<>
                    {Single && Single[imgState-1] && Single[imgState-1]["typ"] === 0 ? (
                    <img src={Single[imgState-1]["src"]} className='v-display-img-full'
                        style={loading ? {"display":"none"} : {} }
                        onLoad={imageLoaded}
                    />
                ) : (<>
                    {type === 1 && Single && Single[imgState-1] && Array.isArray(Single[imgState-1]["src"]) && Single[imgState-1]["src"].map((imgV, imgKey)=>{
                        return(
                            <img src={imgV} className='v-display-img-full'
                                style={loading ? {"display":"none"} : {} }
                                onLoad={imageLoaded}
                            />
                        )
                    })

                    }
                </>)
                }
                </>)
                : (<></>)
                }
                
                
            </>)
            : (<></>)
            
            }
            
                    <img src={nextArr} className='v-arr-l'
                            onClick={()=>{
                                if(imgState > 0){
                                    setLoading(true)
                                }
                                setImgState((curr)=>(
                                curr > 0 ? curr - 1 : 0
                            ))}}
                        />
                        <img src={prevArr} className='v-arr-r'
                            onClick={()=>{
                                if(imgState < state-1){
                                    setLoading(true)
                                }
                                setImgState((curr)=>(
                                curr < state-1 ? curr + 1 : curr
                            ))}}
                            
                        />

        </div> 
    );
}

export default ViewImages;